import { checkValue } from "../../../functions/checkValue";
import { formatDate } from "../../../functions/dateTime/formatDate";

export const formatSitesCylinderExcelData = (sitesData) => {
  return sitesData.map((s) => {
    const operationalCylinder = s.cylinders.find((c) => c.isOperational);
    const opeCylStatus = operationalCylinder
      ? operationalCylinder.currentState.isFilled
        ? "(F)"
        : "(E)"
      : "";
    const getSecondaryCy = s.cylinders.filter((c) => c.isOperational === false);
    const secondaryCySerialNo = getSecondaryCy.map(
      (c) => `${c.serialNumber} ${c.currentState.isFilled ? "(F)" : "(E)"}`,
    );
    return {
      "Site Name": s.name,
      "Site ID": String(s.id),
      "Machin ID": String(checkValue(s.machineID)),
      "FT Name": checkValue(s.jbccFieldTechnician?.fullName),
      Supervisor: checkValue(s.jbccFieldTechnician?.jbccSupervisor?.fullName),
      "Primary Cylinder": `${checkValue(operationalCylinder?.serialNumber)}${opeCylStatus}`,
      "Secondary Cylinder": secondaryCySerialNo.length
        ? secondaryCySerialNo.join(", ")
        : "-",
    };
  });
};


export const formatTransitExcelData = (cylData) => {
  return cylData.map((c) => ({
    "Cylinder NO.": String(c.cylinder_no),
    "Dispatch Date": formatDate(c.dispatched_date),
    "Dispatched From Station": c.dispatched_from_station,
    "Dispatch By": c.dispatched_by,
    "Vehicle NO.": c.vehicle_no,
  }));
};
